export default {
  FILM: { width: 600, height: 400 },
  SMALL: { width: 600, height: 340 },
  MEDIUM: { width: 800, height: 450 },
  LARGE: { width: 1200, height: 675 },
  AVATAR: { width: 400, height: 400 },
  ORIGINAL: { width: '', height: '' }
}
